import React, {
  useContext,
  useReducer,
  useEffect,
  useState,
  Dispatch,
} from 'react';
import { B2B_USER_SUCCESS } from '../../Helpers/Constant';
import b2bReducer from '../../Reducers/AuthReducer/B2bReducers';
import { httpService } from '../../Helpers/Fetcher/axios';
import { B2BContext } from '../initialLizeContext';
export type B2BContextType = {
  state: TB2BUSER;
  dispatch: Dispatch<any>; // Replace 'any' with a more specific action type if available
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};
// Initial state type
export type TB2BUSER = {
  b2bUser: {
    b2b_email: string | null;
    b2b_first_name: string | null;
    b2b_id: number | null;
    b2b_last_name: string | null;
    b2b_phone: string | null;
    b2b_photo: string | null;
    b2b_type: string | null;
    token: string | null;
    type: string | null;
    // b2b_country: '';
    // b2b_created_at: '2025-04-06 10:29:52';
    // b2b_company_brief: null;
    // b2b_organization: 'Maldonado Chavez LLC';
    // b2b_designation: 'Cum facere in magni ';
    // b2b_website: 'https://www.vecababecubuhac.me';
    // b2b_address: 'Numquam eum esse dui';
    // b2b_status: 'pending';
    // b2b_telephone_number: '246';

    // b2b_business_type: 'Tour Operator';
    // b2b_id_type: 'Passport';
    // b2b_id_number: '';
    // b2b_intention: '';
    // b2b_join_year: '';
    // b2b_locations: [
    //   {
    //     location_id: null;
    //     location_name: null;
    //     location_type: null;
    //   }
    // ];
  };
  isLoading: boolean;
};

export const initialState: TB2BUSER = {
  b2bUser: {
    b2b_email: null,
    b2b_first_name: null,
    b2b_id: null,
    b2b_last_name: null,
    b2b_phone: null,
    b2b_photo: null,
    b2b_type: null,
    type: null,
    token: null,
  },
  isLoading: false,
};

const B2BAuthContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [state, dispatch] = useReducer(b2bReducer, initialState);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const toab_fair = localStorage.getItem('toab_fair');
      if (toab_fair) {
        setIsLoading(true);
        try {
          //this istoken verify is not verified throw error this error is not need i need axios error so this line code are commented
          // const { payload } = await jose.jwtVerify(
          //   toab_fair,
          //   new TextEncoder().encode('FaTO5b$eCzw!Ukw8^d*UUf*JABbeIrR')
          // );

          // when reload   this api is call and get data(if token is valid) if not valid token get error and  b2bContext data will clear
          const { data } = await httpService.get<any>({
            url: `/api/b2b/profile`,
          });

          dispatch({
            type: B2B_USER_SUCCESS,
            payload: { ...data, token: toab_fair },
          });
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
          //dispatch({ type: B2B_USER_FAILED });
        }
      } else {
        setIsLoading(false);
        //dispatch({ type: B2B_USER_FAILED });
      }
    })();
  }, []);

  return (
    <B2BContext.Provider value={{ state, dispatch, isLoading, setIsLoading }}>
      {children}
    </B2BContext.Provider>
  );
};

const B2BAuthContext = () => {
  const context = useContext(B2BContext);
  if (!context) {
    throw new Error(
      'B2BAuthContext must be used within a B2BAuthContextProvider'
    );
  }
  return context;
};

export { B2BAuthContextProvider, B2BAuthContext };
